export default function LandingFounder() {
  return (
    <div className="bg-white py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto grid max-w-2xl grid-cols-1 items-start gap-x-16 gap-y-10 lg:mx-0 lg:max-w-none lg:grid-cols-3">
          <div className="mx-auto w-full max-w-xs lg:mx-0">
            <div className="overflow-hidden rounded-2xl bg-gray-100 shadow-xl shadow-gray-900/10 ring-1 ring-gray-200">
              <img
                src="/award-winning.png"
                alt="Sergey, founder of Speech Agenda, holding a speech contest trophy"
                className="aspect-[3/4] w-full object-cover"
              />
            </div>
          </div>
          <div className="lg:col-span-2">
            <h2 className="text-base font-semibold leading-7 text-indigo-600">
              Built by a VPE, not a vendor
            </h2>
            <p className="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
              I had this exact problem
            </p>
            <div className="mt-6 space-y-6 text-lg leading-8 text-gray-600">
              <p>
                I&apos;ve served as VP of Education and Club President, and
                I&apos;ve stood on the contest stage too - first place in our
                area contest, second in the division
                {/* TODO(SPE-79): name the founder's club here once the public wording for the 1+ year claim is decided. */}
              </p>
              <p>
                I&apos;ve also been the officer with the spreadsheet: the chase
                texts, the Tuesday-night dropout, the same agenda rebuilt every
                single week
              </p>
              <p>
                As a software engineering lead, I built the tool I needed. My
                club has run every meeting on Speech Agenda for over a year.
                Tell me what your club needs -{' '}
                <a
                  href="mailto:support@speechagenda.com"
                  className="font-semibold text-indigo-600 hover:text-indigo-500">
                  support@speechagenda.com
                </a>{' '}
                goes straight to me
              </p>
            </div>
            <p className="mt-8 text-base font-semibold text-gray-900">
              - Sergey, founder of Speech Agenda
            </p>
            <p className="text-sm leading-6 text-gray-500">
              Former VP of Education &amp; Club President
            </p>
            {/* TODO(SPE-79): add the Sergeant at Arms quote here once written permission is granted, attributed as "— [Name], Sergeant at Arms of [club], the first club on Speech Agenda". */}
          </div>
        </div>
      </div>
    </div>
  )
}
